import { Button, Modal } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  deleteAccountRole,
  getAllRoles,
} from "../../../actionCreator/roleManagementActionCreator";
import { useAlert } from "../../../context/AlertProvider";

const DeleteRole = ({ isOpen, handleCancel, callback }) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [isLoading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    const res = await dispatch(deleteAccountRole(isOpen?.id));
    if (res?.status === 204) {
      showAlert("success", `${isOpen?.name} role deleted successfully!`);
      dispatch(getAllRoles());
      callback();
    } else {
      showAlert("error", res?.response?.data?.title);
    }
    setLoading(false);
  };

  return (
    <Modal
      title={
        <div
          className="heading24px text-color-1C1C1C roboto-medium"
          style={{ padding: "20px 24px 10px" }}
        >
          Delete Role
        </div>
      }
      className="delete-popup"
      open={isOpen}
      centered
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
    >
      <div style={{ padding: "20px 24px 10px" }}>
        Are you sure you want to delete the role "{isOpen?.name}"? This action
        cannot be undone.
        <div
          className="mt20 d-flex justify-content-end align-items-center mb10"
          style={{ gap: 20 }}
        >
          <Button className="light-btn" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            disabled={isLoading}
            className="stop-sync"
            onClick={() => {
              handleDelete();
              handleCancel();
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteRole;
